module.exports = ".socket {\n    cursor: pointer;\n    max-width:80%;\n    margin-top:6px;\n    /* overflow:hidden; */\n}\n\n.socket-btn {\n   /* overflow:hidden;\n   max-height:105px;\n   min-width:5px; */\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/socket/socket.component.css
// module id = ./src/app/socket/socket.component.css
// module chunks = main